import { useEffect, useState } from 'react'
import Header from 'components/Header/Header'
import './style.css'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties'
import { motion } from 'framer-motion';
import { NewsData, newsData } from 'data/news'

const hashColor = ['#4E59B7', '#4CC4CC', '#4CCC70', '#D338A8', '#944CCC']
const shuffleArray = <T,>(array: T[]): T[] => {
  return [...array].sort(() => Math.random() - 0.5);
};

const News = () => {
  const [list, setList] = useState<NewsData[]>([])

  useEffect(() => {
    const temp = newsData.map(arr => (
      { ...arr, hashColor: shuffleArray(hashColor) }
    ));
    setList(temp)
  }, [])

  return (
    <>
      <Header isOverLay={true} isWhite={false} bgWhite={true} />
      <section className='flex justify-center items-center bg-white py-20 min-h-screen select-none container'>
        <div
          className="gap-4 grid grid-cols-4 tablet:grid-cols-1 wide:grid-cols-2 wideLg:grid-cols-3">
          {
            list.map((item, idx) => (
              <motion.div
                key={idx}
                className={`flex flex-col justify-end items-center bg-[black] w-[100%] h-[540px] mobile:w-[90vw] cardEl text-black group`}
                style={{
                  backgroundImage: `url(${item.img})`,
                  backgroundSize: 'cover', // 이미지 크기 조정
                  backgroundPosition: 'center', // 이미지 위치
                  backgroundRepeat: 'no-repeat', // 이미지 반복 제거
                }}
                transition={{ delay: 0.1 * idx }}
                initial={START_ANIMATION_PROPERTY}
                whileInView={END_ANIMATION_PROPERTY}
                viewport={VIEWPORT_PROPERTY} >
                <div
                  className='flex flex-col justify-between bg-[rgba(255,255,255,0.4)] group-hover:bg-white tablet:bg-white p-4 w-full h-56 overflow-hidden transition-all duration-300 ease-in-out'
                >
                  <div>
                    <div className='flex justify-between items-center mb-2'>
                      <p className='text-[gray] text-lg'>{item.date}</p>
                      <p className='text-[gray] text-lg'>{item.company}</p>
                    </div>
                    <p className='font-semibold text-xl'>{item.title}</p>
                  </div>

                  <div className='flex flex-wrap gap-1'>
                    {
                      item.hashTag.map((items, idx) => (
                        <div key={idx}
                          className='flex justify-center items-center px-3 py-2 rounded-full'
                          style={{ backgroundColor: item.hashColor[idx] }}>
                          {
                            items.includes('http') ?
                              <a className='text-white text-sm' href={items} target='_blank' rel="noopener noreferrer">
                                #{items}
                              </a> :
                              <p className='text-white text-sm'>
                                #{items}
                              </p>
                          }
                        </div>
                      ))
                    }
                  </div>
                </div>
              </motion.div>
            ))
          }
        </div>
      </section>
    </>
  )
}

export default News
